var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    fill: "none",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 5h16m-1 0l-.867 12.142A2 2 0 0113.138 19H4.862a2 2 0 01-1.995-1.858L2 5h14zM7 9v6-6zm4 0v6-6zm1-4V2a1 1 0 00-1-1H7a1 1 0 00-1 1v3h6z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default __webpack_public_path__ + "static/media/delete.a2be360d.svg";
export { SvgDelete as ReactComponent };